import { useEffect, useRef, useState } from 'react';

interface CameraCaptureProps {
  onCapture: (file: File) => void;
  onCancel: () => void;
}

const CameraCapture = ({ onCapture, onCancel }: CameraCaptureProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [stream, setStream] = useState<MediaStream | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let activeStream: MediaStream | null = null;
    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: 'environment' }, audio: false })
      .then((s) => {
        activeStream = s;
        setStream(s);
        if (videoRef.current) {
          videoRef.current.srcObject = s;
        }
      })
      .catch(() => {
        setError('Camera kon niet worden geopend.');
      });
    return () => {
      if (activeStream) {
        activeStream.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  const takePhoto = () => {
    if (!videoRef.current || !stream) return;
    const video = videoRef.current;
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth || 640;
    canvas.height = video.videoHeight || 480;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.drawImage(video, 0, 0);
    canvas.toBlob(
      (blob) => {
        if (!blob) return;
        const file = new File([blob], `photo-${Date.now()}.jpg`, { type: 'image/jpeg' });
        onCapture(file);
      },
      'image/jpeg',
      0.9,
    );
  };

  return (
    <div className="camera-capture-overlay" onClick={onCancel}>
      <div className="camera-capture-dialog" onClick={(event) => event.stopPropagation()}>
        {error ? (
          <p className="camera-capture-error">{error}</p>
        ) : (
          <video ref={videoRef} autoPlay playsInline className="camera-capture-video" />
        )}
        <div className="camera-capture-actions">
          <button type="button" className="button secondary" onClick={onCancel}>
            Annuleren
          </button>
          <button type="button" className="button primary" onClick={takePhoto} disabled={!stream}>
            Foto maken
          </button>
        </div>
      </div>
    </div>
  );
};

export default CameraCapture;
